import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface IArcProps extends IBaseElementProps {
	strokeOneClass?: string;
	strokeOneColor?: string;
	strokeOneWidth?: number;
	strokeTwoClass?: string;
	strokeTwoColor?: string;
	strokeTwoWidth?: number;
	strokeThreeClass?: string;
	strokeThreeColor?: string;
	strokeThreeWidth?: number;
}

const HeroArc: React.FC<IArcProps> = ({
	className,
	classNames = [],
	strokeOneColor,
	strokeOneWidth,
	strokeTwoColor,
	strokeTwoWidth,
	strokeThreeColor,
	strokeThreeWidth,
}) => (
	<svg
		width="731"
		height="627"
		viewBox="0 0 731 627"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			className="hero-path-arc-one"
			d="M-2.74477 228.571C-319.923 21.3648 -706.422 -51.3561 -1077.22 26.4059C-1448.01 104.168 -1772.73 326.043 -1979.94 643.221C-2187.14 960.399 -2259.86 1346.9 -2182.1 1717.69C-2104.34 2088.49 -1882.46 2413.21 -1565.29 2620.41C-1248.11 2827.62 -861.609 2900.34 -490.814 2822.58C-120.018 2744.82 204.699 2522.94 411.905 2205.76C619.111 1888.59 691.832 1502.09 614.07 1131.29C536.309 760.495 314.434 435.777 -2.74441 228.571L-2.74477 228.571Z"
			stroke={strokeOneColor}
			strokeWidth={strokeOneWidth}
		/>
		<path
			className="hero-path-arc-two"
			d="M-2.3796 63.4778C-181.11 -39.1712 -378.308 -105.612 -582.715 -132.05C-787.122 -158.488 -994.734 -144.407 -1193.7 -90.6094C-1392.66 -36.8121 -1579.08 55.6475 -1742.32 181.49C-1905.55 307.333 -2042.4 464.095 -2145.05 642.825C-2247.69 821.555 -2314.14 1018.75 -2340.57 1223.16C-2367.01 1427.57 -2352.93 1635.18 -2299.13 1834.14C-2245.34 2033.11 -2152.88 2219.53 -2027.03 2382.76C-1901.19 2545.99 -1744.43 2682.84 -1565.7 2785.49C-1386.97 2888.14 -1189.77 2954.58 -985.364 2981.02C-780.957 3007.46 -573.344 2993.38 -374.379 2939.58C-175.414 2885.78 11.0065 2793.32 174.239 2667.48C337.471 2541.64 474.318 2384.87 576.967 2206.14C679.616 2027.41 746.057 1830.22 772.495 1625.81C798.933 1421.4 784.852 1213.79 731.054 1014.82C677.257 815.859 584.797 629.438 458.955 466.206C333.112 302.974 176.35 166.127 -2.37984 63.4777L-2.3796 63.4778Z"
			stroke={strokeTwoColor}
			strokeWidth={strokeTwoWidth}
		/>
		<path
			className="hero-path-arc-three"
			d="M734.928 637.946C631.636 438.477 490.068 261.307 318.305 116.55C146.543 -28.2068 -52.0496 -137.715 -266.133 -205.722C-480.217 -273.73 -705.6 -298.904 -929.413 -279.808C-1153.23 -260.712 -1371.09 -197.72 -1570.55 -94.4284C-1770.02 8.86338 -1947.19 150.432 -2091.95 322.194C-2236.71 493.957 -2346.22 692.549 -2414.22 906.633C-2482.23 1120.72 -2507.4 1346.1 -2488.31 1569.91C-2469.21 1793.73 -2406.22 2011.59 -2302.93 2211.05C-2199.64 2410.52 -2058.07 2587.69 -1886.31 2732.45C-1714.54 2877.21 -1515.95 2986.71 -1301.87 3054.72C-1087.78 3122.73 -862.4 3147.9 -638.587 3128.81C-414.775 3109.71 -196.914 3046.72 2.55405 2943.43C202.023 2840.14 379.193 2698.57 523.95 2526.81C668.707 2355.04 778.215 2156.45 846.222 1942.37C914.229 1728.28 939.404 1502.9 920.308 1279.09C901.212 1055.27 838.22 837.414 734.928 637.946L734.928 637.946Z"
			stroke={strokeThreeColor}
			strokeWidth={strokeThreeWidth}
		/>
	</svg>
);

export default HeroArc;
